import { Version } from '@repo/toolkit/types'

import { EnrollmentCenter } from '../../../lib/types/models/enrollment-center/enrollment-center'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterGroupEnrollments(
  centerId: number,
  groupId: number,
  version: Version = 'FULL'
) {
  return restApiClient
    .url(
      encodeNestedObject<{ version: Version }>(
        constructApiUrl(API.centers.getCenterGroupEnrollments.url, { id: centerId, groupId }),
        { version }
      )
    )
    .get<EnrollmentCenter[]>()
}
